import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useDropzone } from "react-dropzone";
import { toast } from 'react-toastify';
import  swal from "sweetalert";
import Modal from "./../../elements/Modal";
import { Button } from "./../../elements/Button";
import InputGroup from "./../../elements/InputGroup";
import commoncss from "./../../css/common.module.css";
import buttoncss from "./../../css/button.module.css";
import userProfileCss from '../../../myfin_v2/css/userprofile.module.css';
import { ReactComponent as HideIcon } from "../../../myfin_v2/assets/icons/hide.svg";
import { ReactComponent as ShowIcon } from "../../../myfin_v2/assets/icons/show.svg";
import { ReactComponent as ImgIcon } from "../../assets/icons/img.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { ReactComponent as PlusIcon } from "../../assets/icons/plusprimary.svg";
import defaultUserImg from "../../../assets/Image/defaultUserImage.png";

import {
    updateProfileData
} from "../../../WorkSpace/Components/ApiServices/apiHandler";

const UpdateProfileModal = ({
    handleClose,
    setUpdateProfileModal,
    setprofile,
    setRefreshKey
}) => {

    const [ShowOldPwd, setShowOldPwd] = useState(false);
    const [ShowNewPwd, setShowNewPwd] = useState(false);
    const [ShowReConfirmPwd, setShowReConfirmPwd] = useState(false);
    const [uploadedFile, setUploadedFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(
        setprofile? setprofile?.profile_img?.url : null
    );
    const [imageName, setImageName] = useState(
        setprofile? setprofile?.profile_img?.originalName : null
    );

    const [profileData, setProfileData] = useState({
        id:setprofile.id,
        name: setprofile.name || "",
        email: setprofile.email || "",
        OldPassword: "",
        password: "",
        confirmPassword: "",
    });

    const profileDataChange = (e) => {
        const { name, value } = e.target;
        setProfileData((prev) => ({ ...prev, [name]: value }));
    };

    const onDrop = (acceptedFiles) => {
        const file = acceptedFiles[0];
        if (!file) return;

        setUploadedFile(file);
        setPreviewUrl(URL.createObjectURL(file));
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: ".jpeg, .png, .webp, .jpg, .heic, .avif",
    });

    useEffect(() => {
        return () => {
            if (previewUrl) {
                URL.revokeObjectURL(previewUrl);
            }
        };
    }, [previewUrl]);

    const handleUpdateProfile = async () => {

        const formData = new FormData();

        for (let key in profileData) {
          formData.append(key, profileData[key]);
        }

        if (uploadedFile) {
          formData.append("profile_image", uploadedFile);
        }

        if (!uploadedFile && !imageName) {
          formData.append("deleteProfileImage", "Y");
        }

        try {
            const response = await updateProfileData(formData);

            if (response.status === 200) {
                handleClose();
                toast.success("Profile Updated");
                // window.location.reload();
                setRefreshKey(prev => prev + 1);  
            } else {
                swal("Error", `Error: ${response.data?.error || "Something went wrong"}`, "error");
            }
        } catch (error) {
            swal("Error", `Error: ${error.response?.data?.error || error.message}`, "error");
        }


    }

    // const result = await updateProfileData();

    // const handleUpdate = (id, e) => {
    // 	const auth = localStorage.getItem("auth_token");
    // 	let headers = {
    // 		"x-auth-token": auth,
    // 		"Content-Type": "application/json",
    // 	};
    // 	axios
    // 		.post(`api/v1/auth/update-profile`, setprofile, { headers })
    // 		.then((response) => {
    // 			if (response.status === 200) {
    // 				swal("Success", "Password Updated Successfully", "success").then(() => {
    // 					logoutUser().then(response => {
    // 						toast.success("Logout Successfully");
    // 						logout();
    // 						history.push("/");
    // 					}).catch(error => {
    // 						toast.error(error.response?.data?.error || "Logout Failed!");
    // 					})
    // 				});

    // 			}
    // 		})
    // 		.catch((error) => {
    // 			swal("Error", error.response.data.message, "error");
    // 		});
    // }



    return (
        <Modal
            minHeight={"350px"}
            width={"45%"}
            title="Edit Profile"
            headerActions={
                <CloseIcon
                    onClick={() => {
                        handleClose();
                    }}
                    className="clickable"
                />
            }
            footerActions={
                <>
                    <Button
                        btnColor={buttoncss.secondary}
                        onClick={() => {
                            setUpdateProfileModal(false);
                            handleClose();
                        }}
                        label="Cancel"
                    />

                    <Button
                        btnColor={buttoncss.primary}
                        label="Update & Save"
                        onClick={() => {
                            // applyFilter(customFilter ? "customFilter" : "basicFilter");
                            handleUpdateProfile();
                        }}
                    />
                </>
            }
        >
            <div class={`${commoncss.pdlr15}`}>
                <div class={`${commoncss.pdlr15}`}>
                    <div>
                        {!uploadedFile && !previewUrl && !imageName && (
                            <div className={userProfileCss.defaultUpload}>
                                <img 
                                    className={userProfileCss.userImagePreview}
                                    src={defaultUserImg}
                                    alt='user_img'
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = defaultUserImg;
                                    }} 
                                />
                                <button
                                    type="button"
                                    className={userProfileCss.previewNameButton}
                                    onClick={() => document.getElementById("profileInput").click()}
                                >
                                    <PlusIcon height={19} />
                                    Add Profile Picture
                                </button>
                                <input
                                    id="profileInput"
                                    type="file"
                                    accept=".jpeg,.png,.webp,.jpg,.heic,.avif"
                                    style={{ display: "none" }}
                                    onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (!file) return;
                                    setUploadedFile(file);
                                    setPreviewUrl(URL.createObjectURL(file));
                                    }}
                                />
                            </div>
                        )}

                        <motion.div
                            className={`${commoncss.dFlex} mt-2 mb-3`}
                            style={{ gap: "10px" }}
                        >
                            {previewUrl && (
                                <div>
                                    <img
                                        className={userProfileCss.userImagePreview}
                                        src={previewUrl}
                                        alt="Preview"
                                    />
                                </div>
                            )}
                            {uploadedFile && (
                                <button
                                    type="button"
                                    className={userProfileCss.previewNameButton}
                                >
                                    <ImgIcon height={19} />
                                    {uploadedFile.name}{" "}
                                    <CloseIcon
                                        height={15}
                                        onClick={() => {
                                            setUploadedFile(null);
                                            setPreviewUrl(null);
                                        }}
                                    />
                                </button>
                            )}

                            {imageName && (
                                <>
                                    <button
                                        type="button"
                                        className={userProfileCss.previewNameButton}
                                    >
                                        <ImgIcon height={19} />
                                        {imageName}{" "}
                                        <CloseIcon
                                            height={15}
                                            onClick={() => {
                                                setImageName(null);
                                                setPreviewUrl(null);
                                            }}
                                        />
                                    </button>
                                    <span
                                        className={`${commoncss.primaryLable2} ${commoncss.clickable} ml-1`}
                                        onClick={() => {
                                            setImageName(null);
                                            setPreviewUrl(null);
                                        }}
                                    >
                                        Replace Image
                                    </span>
                                </>
                            )}
                        </motion.div>
                    </div>

                    {/* <div className="mt-1">
                        <span className="input-label">Upload Logo</span>
                        <div
                            className={`d-flex justify-content-center align-items-center radius-8px custom-bg-white-150 ${commoncss.dashedCard}`}
                            style={{ height: "70px" }}
                            {...getRootProps()}
                        >
                            <input {...getInputProps()} />
                            <div>
                                <div className="d-flex flex-column align-items-center">
                                    <div
                                        className="d-flex justify-content-center align-items-center"
                                        style={{
                                            height: "100px",
                                            "flex-direction": "column",
                                        }}
                                    >
                                        <div
                                            style={{ color: "#B3C0BD" }}
                                        >
                                            Drag and drop your file here
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    <InputGroup
                        label="Username"
                        inputs={[
                            <>
                                <input
                                    type="text"
                                    name="name"
                                    value={profileData.name}
                                    // onChange={profileDataChange}
                                    onChange={(e) => {
                                        profileDataChange(e);
                                        console.log("profileData after change:", {
                                            ...profileData,
                                            [e.target.name]: e.target.value
                                        });
                                    }}
                                />
                            </>,
                        ]}
                    />

                    <InputGroup
                        label="Email Address"
                        inputs={[
                            <>
                                <input
                                    type="email"
                                    name="email"
                                    value={profileData.email}
                                    disabled
                                    style={{ cursor: "not-allowed" }}
                                />
                            </>,
                        ]}
                    />

                    <div className={userProfileCss.resetPasswordSeperation}>
                        <span>Reset Password</span>
                        <hr style={{ flex: "1", borderTop: "1px solid #ccd5d3" }} />
                    </div>

                    <InputGroup
                        label="Old Password"
                        inputs={[
                            <>
                                <input
                                    name="OldPassword"
                                    type={!ShowOldPwd ? "password" : "text"}
                                    onChange={profileDataChange}
                                />
                                <span className="icon" style={{ cursor: "pointer", pointerEvents: "auto" }} onClick={() => setShowOldPwd(!ShowOldPwd)}>
                                    {ShowOldPwd ? <ShowIcon height={18} /> : <HideIcon height={18} />}
                                </span>
                            </>,
                        ]}
                    />


                    <InputGroup
                        label="New Password"
                        inputs={[
                            <>
                                <input
                                    name="password"
                                    type={!ShowNewPwd ? "password" : "text"}
                                    onChange={profileDataChange}
                                />
                                <span className="icon" style={{ cursor: "pointer", pointerEvents: "auto" }} onClick={() => setShowNewPwd(!ShowNewPwd)}>
                                    {ShowNewPwd ? <ShowIcon height={18} /> : <HideIcon height={18} />}
                                </span>
                            </>,
                        ]}
                    />

                    <InputGroup
                        label="Confirm Password"
                        inputs={[
                            <>
                                <input
                                    name="confirmPassword"
                                    type={!ShowReConfirmPwd ? "password" : "text"}
                                    onChange={profileDataChange}
                                />
                                <span className="icon" style={{ cursor: "pointer", pointerEvents: "auto" }} onClick={() => setShowReConfirmPwd(!ShowReConfirmPwd)}>
                                    {ShowReConfirmPwd ? <ShowIcon height={18} /> : <HideIcon height={18} />}
                                </span>
                            </>,
                        ]}
                    />

                </div>

            </div>
        </Modal>
    )

}


export default UpdateProfileModal;